export const KEYCLOAK = "keycloak";
export const ENTRA = "entra";

const KNOWN_PROVIDERS = [KEYCLOAK, ENTRA];

/**
 * Parse a comma/semicolon separated provider list, ignoring unknown names.
 * @param {string} value - Provider list.
 * @returns Provider names.
 */
export const parseProviders = (value) => {
  const providers = [];

  for (const part of (value || "").split(/[,;]/)) {
    const name = part.trim().toLowerCase();
    if (KNOWN_PROVIDERS.includes(name) && !providers.includes(name))
      providers.push(name);
  }

  return providers;
};

/**
 * Get the providers configured for this deployment.
 * The container writes REACT_APP_AUTH_PROVIDERS at startup; when it is missing
 * (e.g. a stale env-constants.js) Keycloak is used, as before Entra ID support.
 * @param {object} env - Environment constants.
 * @returns Provider names.
 */
export const getConfiguredProviders = (env = window.EnvConstants || {}) => {
  const providers = parseProviders(env.REACT_APP_AUTH_PROVIDERS);
  return providers.length > 0 ? providers : [KEYCLOAK];
};
